var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
export var PlaceholderBase = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  background-color: ", ";\n  width: ", ";\n  margin: ", ";\n"], ["\n  border-radius: 4px;\n  background-color: ", ";\n  width: ", ";\n  margin: ", ";\n"])), function (_a) {
    var type = _a.type;
    return (type === "dark" ? greys.mediumLight : greys.light);
}, function (_a) {
    var width = _a.width;
    return width || "100%";
}, function (_a) {
    var margin = _a.margin;
    return margin || "0 0 10px 0";
});
var PlaceholderBar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  height: ", ";\n"], ["\n  ", "\n  height: ", ";\n"])), PlaceholderBase, function (_a) {
    var type = _a.type;
    return (type === "dark" ? "15px" : "8px");
});
export var PlaceholderSquare = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  height: 100px;\n"], ["\n  ", "\n  height: 100px;\n"])), PlaceholderBase);
export var PlaceholderContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-height: 200px;\n  padding: ", ";\n  width: 100%;\n  border-radius: 2px;\n  border: 2px solid ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  min-height: 200px;\n  padding: ", ";\n  width: 100%;\n  border-radius: 2px;\n  border: 2px solid ", ";\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var padding = _a.padding;
    return padding || "0";
}, greys.light, function (_a) {
    var border = _a.border;
    return border === "none" && "border: none;";
}, function (_a) {
    var border = _a.border;
    return border === "dotted" && "border: 2px dotted " + greys.medium + ";";
}, function (_a) {
    var margin = _a.margin;
    return margin && "margin: " + margin + ";";
});
export default PlaceholderBar;
export { default as PlaceholderGrid } from "./Grid";
export { default as PlaceholderButton } from "./Button";
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
